import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const SofaIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-sofa"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M55.0001 26C55.5129358 26 55.9356072 26.3860402 55.9933723 26.8833789L56.0001 27 56.0001 29C56.0001 29.5522847 55.5523847 30 55.0001 30 54.4872642 30 54.0645928 29.6139598 54.0068277 29.1166211L54.0001 29 54.0001 27C54.0001 26.4477153 54.4478153 26 55.0001 26ZM13.0001 26C13.5129358 26 13.9356072 26.3860402 13.9933723 26.8833789L14.0001 27 14.0001 29C14.0001 29.5522847 13.5523847 30 13.0001 30 12.4872642 30 12.0645928 29.6139598 12.0068277 29.1166211L12.0001 29 12.0001 27C12.0001 26.4477153 12.4478153 26 13.0001 26Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <g transform="translate(7 5)">
          <path
            d="M24,-1 L9,-1 C6.79071525,-1 5,0.79071525 5,3 L5,16 L28,16 L28,3 C28,0.79071525 26.2092847,-1 24,-1 Z M24,1 L24.1492805,1.00548487 C25.184255,1.08182223 26,1.94549908 26,3 L26,14 L7,14 L7,3 C7,1.89528475 7.89528475,1 9,1 L24,1 Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
          <path
            d="M45,-1 L30,-1 C27.7907153,-1 26,0.79071525 26,3 L26,16 L49,16 L49,3 C49,0.79071525 47.2092847,-1 45,-1 Z M45,1 L45.1492805,1.00548487 C46.184255,1.08182223 47,1.94549908 47,3 L47,14 L28,14 L28,3 C28,1.89528475 28.8952847,1 30,1 L45,1 Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
          <path
            d="M4,6 L2,6 C0.34271525,6 -1,7.34271525 -1,9 L-1,19 C-1,20.6572847 0.34271525,22 2,22 L52,22 C53.6572847,22 55,20.6572847 55,19 L55,9 C55,7.34271525 53.6572847,6 52,6 L50,6 L49.8236843,6.0050911 C48.2485197,6.09630947 47,7.40190399 47,9 L47,14 L7,14 L7,9 C7,7.34271525 5.65728475,6 4,6 Z M2,8 L4,8 C4.55271525,8 5,8.44728475 5,9 L5,16 L49,16 L49,9 C49,8.44728475 49.4472847,8 50,8 L52,8 C52.5527153,8 53,8.44728475 53,9 L53,19 C53,19.5527153 52.5527153,20 52,20 L2,20 C1.44728475,20 1,19.5527153 1,19 L1,9 C1,8.44728475 1.44728475,8 2,8 Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
          <path
            d="M7.0001 13 7.0001 14 26.0001 14 26.0001 13C26.0001 11.343 24.6571 10 23.0001 10L10.0001 10C8.3431 10 7.0001 11.343 7.0001 13M28.0002 13 28.0002 14 47.0002 14 47.0002 13C47.0002 11.343 45.6572 10 44.0002 10L31.0002 10C29.3432 10 28.0002 11.343 28.0002 13M14 5C14 5.552 13.552 6 13 6 12.448 6 12 5.552 12 5 12 4.448 12.448 4 13 4 13.552 4 14 4.448 14 5M21 5C21 5.552 20.552 6 20 6 19.448 6 19 5.552 19 5 19 4.448 19.448 4 20 4 20.552 4 21 4.448 21 5M35 5C35 5.552 34.552 6 34 6 33.448 6 33 5.552 33 5 33 4.448 33.448 4 34 4 34.552 4 35 4.448 35 5M42 5C42 5.552 41.552 6 41 6 40.448 6 40 5.552 40 5 40 4.448 40.448 4 41 4 41.552 4 42 4.448 42 5"
            fill="#0050B3"
            className={styles.interactiveColor}
          />
        </g>
      </g>
    </Icon>
  )
}
